module.exports = __webpack_public_path__ + "img/img-132.e8e944e2.png";